// Touch/swipe functionality for main product media gallery - Enhanced sensitivity
(() => {
  const gallery = document.querySelector('.product__media-list.slider--mobile');
  
  if (!gallery) return;

  let isDown = false;
  let startX = 0;
  let startScroll = 0;
  let currentSlideIndex = 0;
  let slides = [];

  // Initialize slides
  const initSlides = () => {
    slides = [...gallery.querySelectorAll('.product__media-item.slider__slide')];
    if (slides.length === 0) return;
    
    // Find current slide index
    const currentScroll = gallery.scrollLeft;
    const slideWidth = slides[0].offsetWidth;
    currentSlideIndex = Math.round(currentScroll / slideWidth);
  };

  // Go to specific slide
  const goToSlide = (index) => {
    if (index < 0 || index >= slides.length) return;
    currentSlideIndex = index;
    const slideWidth = slides[0].offsetWidth;
    gallery.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
  };

  // Initialize on load
  initSlides();

  const onDown = (x) => {
    isDown = true;
    startX = x;
    startScroll = gallery.scrollLeft;
    gallery.classList.add('is-dragging');
  };

  const onMove = (x) => {
    if (!isDown) return;
    const delta = x - startX;
    gallery.scrollLeft = startScroll - delta;
  };

  const onUp = (x) => {
    if (!isDown) return;
    isDown = false;
    gallery.classList.remove('is-dragging');
    
    // Calculate swipe distance and direction
    const delta = x - startX;
    const minSwipeDistance = 30; // Very sensitive - only 30px needed
    
    if (Math.abs(delta) > minSwipeDistance) {
      if (delta > 0) {
        // Swiped right - go to previous slide
        goToSlide(currentSlideIndex - 1);
      } else {
        // Swiped left - go to next slide
        goToSlide(currentSlideIndex + 1);
      }
    } else {
      // Small movement - snap back to current slide
      goToSlide(currentSlideIndex);
    }
  };

  // Mouse events
  gallery.addEventListener('mousedown', (e) => onDown(e.pageX));
  window.addEventListener('mousemove', (e) => onMove(e.pageX));
  window.addEventListener('mouseup', (e) => onUp(e.pageX));

  // Touch events
  gallery.addEventListener('touchstart', (e) => onDown(e.touches[0].pageX), { passive: true });
  window.addEventListener('touchmove', (e) => onMove(e.touches[0].pageX), { passive: true });
  window.addEventListener('touchend', (e) => onUp(e.changedTouches[0].pageX));

  // Prevent accidental link click while dragging
  gallery.addEventListener('click', (e) => {
    if (gallery.classList.contains('is-dragging')) e.preventDefault();
  });

  // Update slide index on scroll (for manual scrolling)
  gallery.addEventListener('scroll', () => {
    const slideWidth = slides[0]?.offsetWidth || 0;
    if (slideWidth > 0) {
      currentSlideIndex = Math.round(gallery.scrollLeft / slideWidth);
    }
  });

  // Reinitialize on resize
  window.addEventListener('resize', initSlides);
})();
